"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBarComponent = void 0;
var SideBar_1 = require("./SideBar");
Object.defineProperty(exports, "SideBarComponent", { enumerable: true, get: function () { return SideBar_1.SideBarComponent; } });
